
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 2h7v18H4V2z","fill":"#fff","fill-opacity":".3"}}),_c('path',{attrs:{"d":"M14.75 2a1 1 0 01.25.032l.026.007c.05.014.098.032.144.054l.015.008a1 1 0 01.133.077l.019.013c.043.031.083.065.12.102l5.25 5.25A.997.997 0 0121 8.25v12A1.75 1.75 0 0119.25 22H5.75A1.75 1.75 0 014 20.25V3.75c0-.464.185-.91.513-1.237l.128-.117A1.75 1.75 0 015.75 2h9zM6 20h13V9.25h-4.25a1 1 0 01-1-1V4H6v16zm9.5-5.25a1 1 0 110 2h-6a1 1 0 110-2h6zm0-3a1 1 0 110 2h-6a1 1 0 110-2h6zm.25-4.5h1.836L15.75 5.414V7.25z","fill":"#FDFDFD"}})])
          )
        }
      }
    